import {css} from 'styled-components';
import {font, palette} from "styled-theme";

export const AntdStyled = css`
  /* stylelint-disable no-descending-specificity */
  /* stylelint-disable no-duplicate-selectors */

  #root {
    height: 100%;
  }

  /* From dashAppStyle.js */
  font-family: ${font('primary', 0)};

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  a,
  p,
  li,
  input,
  textarea,
  span,
  div,
  img,
  svg {
    &::selection {
      color: #fff;
      background: ${palette('primary', 0)};
    }
  }


  -webkit-overflow-scrolling: touch;

  .isoBoxWrapper.filter-form form.ant-form.list-filter {
    margin-bottom: 0!important;
  }

  /* Listing page */
  /* Done */
  .ant-legacy-form.list-filter {
    margin: 0 0 16px;

    .ant-legacy-form-item:last-child {
      margin-right: 0;
    }
  }

  .ant-form.list-filter {
    margin: 0 0 16px;

    .ant-form-item:last-child {
      margin-right: 0;
    }
  }

  /* Done */
  .ant-legacy-form.list-filter {
    .ant-legacy-form-item {
      margin-bottom: 0;

      .ant-legacy-form-item-label {
        padding-bottom: 2px;
      }
    }
  }

  .ant-form.list-filter,
  .ant-form.report-filter {
    .ant-form-item {
      margin-bottom: 0;
      line-height: 40px;


      .ant-form-item-label {
        /* padding-bottom: 2px; */
        padding: 0 0 8px;
        line-height: 1.5715;
        text-align: left;
        white-space: initial; 
      }
    }
  }

  /**
   * Table
   **/
  .ant-table-measure-row td {
    padding: 0 !important;
  }

  /**
   * Tabs
   **/
  .ant-tabs {
    .ant-tabs-nav {
      .ant-tabs-extra-content {
        /* Done */
        .ant-legacy-form-item {
          margin-bottom: 0;
        }

        .ant-form-item {
          margin-bottom: 0;
          line-height: 40px;
        }
      }
    }
  }

  /**
   *
   **/
  .ant-select {
    .ant-select-dropdown {
      .ant-select-item-empty {
        .ant-empty {
          padding-top: 0;
        }
      }
    }
  }

  .ant-select-item-option-selected{
    .ant-tooltip-inner {
      font-weight: normal;
    }
  }

  /**
   * Inline select (in label)
   **/
  .ant-select.inline {
    width: auto;
    min-width: 44px;
    background: red;
    
    &.inline-no-red {
      background: unset;
    }

    .ant-select-selector {
      height: auto;
      padding: 0;
      border: none;
      box-shadow: none !important;

      &::after {
        line-height: 21px;
      }

      .ant-select-selection-search {
        right: 18px;
        left: 0;

        input {
          height: 21px;
        }
      }

      .ant-select-selection-placeholder,
      .ant-select-selection-item {
        line-height: 22px;
      }
    }

    .ant-select-arrow {
      right: 3px;
    }
  }


  .trigger {
    padding: 0 16px;
    font-size: 18px;
    line-height: 64px;
    cursor: pointer;
    transition: color 0.3s;
  }

  .trigger:hover {
    color: ${palette('primary', 0)};
  }


  .ant-layout-sider-collapsed .anticon {
    font-size: 16px;
  }

  .ant-layout-sider-collapsed .nav-text {
    display: none;
  }

  #root > div:first-child {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
  }

  #root > div:first-child > .ant-layout {
    background: ${palette('secondary', 1)};
  }

  .ant-layout.ant-layout-has-sider {
    position: relative;
    height: 100%;
    background: ${palette('secondary', 1)};

    .isoContentMainOuterLayout {
      position: relative;
      height: calc(100% - 70px);
      margin-top: 70px;
      overflow: hidden;

      @media only screen and (width >= 768px) and (width <= 1199px) {
        flex-shrink: 0;
        width: calc(100% - 80px);
      }

      @media only screen and (width <= 767px) {
        flex-shrink: 0;
        width: 100%;
      }

      .isoContentMainLayout {
        width: 100%;
        height: 100%;
        overflow: auto;
        overflow-x: hidden;
      }
    }
  }

  .ant-layout-content {
    position: relative;
    flex-shrink: 0;
    background: #f1f3f6;
  }

  .ant-layout-footer {
    font-size: 13px;
    text-align: center;
    background: #fff;
    border-top: 1px solid #ededed;

    @media (width <= 767px) {
      padding: 10px 20px;
    }
  }


  .affix {
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 10;
    width: 100%;
    height: 52px;
    padding-left: 240px;
    background: white;
    border-top: 1px solid ${palette('border', 0)};

    &.slim-padding {
      padding-left: 80px;
    }

    &.no-padding {
      padding-left: 0;
    }
  }

  /* Originally from globalStyle.js */

  /* Vertical Form V4 */
  form.ant-form-vertical {
    .ant-row {
      margin-bottom: 12px;

      &:last-child { /* TBR */
        margin-bottom: 0;
      }

      .ant-form-item {
        padding-bottom: 0;
        margin-bottom: 0;

        .ant-form-item-label {
          padding-bottom: 4px;
        }
      }
    }

    .invoice-detail-table {
      .ant-row {
        /* remove the margin-bottom due to the antd form */
        margin-bottom: 0; 
      }
    }
  }

  .ant-menu-item .ant-menu-item-icon + span,
  .ant-menu-submenu-title .ant-menu-item-icon + span,
  .ant-menu-item .anticon + span,
  .ant-menu-submenu-title .anticon + span {
    margin-left: 0;
  }


  .ant-checkbox {
    display: inline-block;
  }
  
  /* .ant-checkbox-wrapper.ant-checkbox-wrapper-in-form-item {
    line-height: 1.2;
  } */

  /* .ant-form.ant-form-vertical {
    .ant-form-item-control-input {
      .ant-form-item-control-input-content {
        .ant-input-group-wrapper {
          padding: 4px 0;
        }
      }
    }
  } */

  .ant-table-column-title {
    margin-right: 4px;
  }

  .ant-table-column-sorters {
    .ant-table-column-title {
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: keep-all;
    }
  }

  .ant-form.ant-form-horizontal {
    .ant-form-item-control-input {
      .ant-form-item-control-input-content {
        .ant-radio-group.ant-radio-group-outline.vertical {
          /* margin-top: 0; */
        }
      }
    }
  }

  .ant-select-dropdown {
    &.w200 {
      width: 200px !important;
    }

    &.w250 {
      width: 250px !important;
    }

    &.w300 {
      width: 300px !important;
    }

    &.w320 {
      width: 320px !important;
    }

    &.w350 {
      width: 350px !important;
    }

    &.w370 {
      width: 370px !important;
    }
  }

  .ant-table-thead > tr.ant-table-row-hover:not(.ant-table-expanded-row) > td,
  .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row) > td,
  .ant-table-thead > tr:hover:not(.ant-table-expanded-row) > td,
  .ant-table-tbody > tr:hover:not(.ant-table-expanded-row) > td {
    background: #f8f8f8 !important;
  }

  /* Vertical Form */
  /* added v4 version */
  form.ant-legacy-form-vertical {
    .ant-row {
      margin-bottom: 12px;

      &:last-child { /* TBR */
        margin-bottom: 0;
      }

      .ant-legacy-form-item {
        padding-bottom: 0;
        margin-bottom: 0;

        .ant-legacy-form-item-label {
          /* Allows ellipsis */
          display: inline-block;
          padding-bottom: 4px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;


        }
      }
    }
  }

  /* Vertical checkbox & radio group */
  .ant-checkbox-group.vertical,
  .ant-radio-group.vertical {
    display: flex;
    flex-direction: column;
    margin-top: 6px;

    .ant-checkbox-wrapper,
    .ant-radio-wrapper {
      margin-bottom: 4px;

      /* margin-left: 0; */
      /* display: block; */
      /* height: 24px; */
      /* line-height: 24px; */
      /* line-height: 1.25; */
    }
  }

  /* Dropdown Menu */
  .ant-select-dropdown {
    .add-new {
      padding: 5px 12px;
      cursor: pointer;

      &:hover {
        background-color: #e6f7ff;
      }

      &.locked {
        color: rgba(0, 0, 0, 25%);
        cursor: not-allowed;

        &:hover {
          background-color: transparent;
        }
      }
    }

    .ant-divider {
      margin: 6px 0;
    }
  }

  /* END */

  /* Hack for checkbox */
  .ant-checkbox-wrapper {
    margin-right: 8px;
    margin-left: 0 !important;
  }

  /* Calendar Picker */
  .ant-calendar-picker {
    width: 100%;
  }

  /* END */

  /* Page Header */
  .ant-page-header.ant-page-header-ghost {
    width: 100%;
    padding: 0 2px;
    padding-bottom: 10px;

    /* padding-top: 20px; */
  }


  /**
   * Tab bar
   **/
  .ant-tabs-bar {
    /* added v4 version */
    .ant-legacy-form-item {
      margin-bottom: 0;

      .ant-legacy-form-item-control {
        line-height: 36px;
      }
    }

    .ant-form-item {
      margin-bottom: 0;

      .ant-form-item-control {
        line-height: 36px;
      }
    }
  }

  /* Page header */
  .ant-page-header-heading-extra {
    overflow-x: auto;

    /* in file manager */
    &:has(.header-extra-ignore-scroll) {
      overflow-x: revert;
    }
    
    /* > * {
      margin-right: 8px;

      &:last-child {
        margin-right: 0;
      }
    } */
  }

  .ant-page-header-heading-extra .ant-space-item > * {
    &:not(:first-child) {
      margin-right: 0 !important;
      margin-left: 8px !important;
    }
  }

  .ant-row:not(.ant-form-item) {
    &::before,
    &::after {
      display: none;
    }
  }

  a.ant-btn.ant-btn-icon-only {
    vertical-align: top;

    /* padding: 1px 0 !important; */

    span.anticon {
      display: inline-block;
    }
  }

  /* antdv4 */
  .ant-btn:not(.ant-btn-circle, .ant-btn-icon-only) > span.anticon:only-child {
    margin-right: 8px;
  }

  .ant-btn:not(.ant-btn-circle, .ant-btn-icon-only) {
    span.anticon {
      margin-right: 8px;
    }
    
    /* 
    antdV5
    When click, there's a <div> element (due to ant-wave) followed by a <span> element with the "anticon" class
    Retain the margin-right for the <span> element
    */
    div + span.anticon {
      margin-right: 8px;
      font-size: unset;
    }
  }

  .has-success.has-feedback {
    .ant-select {
      .ant-select-selection {
        .ant-select-selection__rendered {
          .ant-select-selection__placeholder {
            display: none !important;
          }
        }
      }
    }
  }

  .ant-select-dropdown {
    .ant-select-dropdown-menu {
      li.inactive {
        color: rgba(0, 0, 0, 40%);
      }
    }
  }

  li.inactive {
    color: rgba(0, 0, 0, 30%) !important;
  }

  .ant-modal-body {
    p {
      margin-bottom: 8px;
    }
  }

  .ant-select-selection-item.ant-select-selection-item-error {
    color: #cf1322;
    background-color: #fff1f0;

    .anticon {
      color: #cf1322;
    }
  }

  .ant-select-multiple.ant-select-selection-item-limit-hit {
    .ant-select-selector {
      cursor: auto !important;
    }

    input.ant-select-selection-search-input {
      display: none !important;
    }
  }

  .checkbox-ellipsis {
    display: flex;

    span:last-child {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  /* .ant-btn > .ant-btn-loading-icon:only-child .anticon.anticon-loading.anticon-spin { */
    /* padding-right: 8px; */
  /* } */
  
  .ant-btn > .ant-btn-loading-icon:only-child {
    padding-right: 8px;
  }

  /* Tooltip */
  .ant-tooltip-inner {
    white-space: initial;
  }
  
  .ant-drawer-content-wrapper {
      max-width: 100vw;
  }

  /* Scroll when menu dropdown is overflow - eg: Print PDF has many form designs */
  .ant-dropdown-menu.ant-dropdown-menu-sub.ant-dropdown-menu-vertical {
    max-height: 98vh;
    overflow-y: auto;
  }

  .ant-dropdown-menu.ant-dropdown-menu-root.ant-dropdown-menu-vertical {
    max-height: 90vh;
    overflow-y: auto;
  }
  
`;
